<div class="pb-[40px]">
  <div
    class="flex justify-between items-center w-full px-[50px] !pt-[23px] !pb-[0.6rem]"
  >
    <div class="header h-[55px] flex items-center pl-[8px]">
      <p class="!m-0">{{ projectName }} - Request For Information</p>
    </div>

    <div class="flex items-center space-x-2">
      <button (click)="handleClose()" type="button" class="close-btn">
        Back
      </button>
      <button
        (click)="handleEdit(rfiId)"
        type="button"
        class="edit-btn btn-primary cursor-pointer"
      >
        Edit
      </button>

      <!-- [ngClass]="
          approvalsStatus === 'approved'
            ? '!bg-[#197741] !border-[#197741]'
            : approvalsStatus === 'rejected'
            ? '!bg-[#ff0000] !border-[#ff0000]'
            : ''
        " 
        {{ approvalResponses ? "Approval Status" : "Send For Approvals" }}
        
        -->
      <!-- <button type="button" class="btn">Send for Approval</button> -->
      <!-- <button
        (click)="approvalResponseView(rfiId, projectId)"
        type="button"
        class="btn"
      >
        Approval Requested
      </button>
      <button
        [ngClass]="
          approvalsStatus === 'approved'
            ? '!bg-[#197741] !border-[#197741]'
            : ''
        "
        type="button"
        class="btn cursor-pointer"
      >
        Approval Sent
      </button> -->

      <div class="container-fluid !pr-[0px] bg-[#ffffff]">
        <div class="relative">
          <div class="rounded flex justify-end">
            <button type="button" (click)="sendToClient()" class="btn !mr-0">
              Send to Client
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mx-[50px] mt-[1.5rem]">
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Project Brief</p>
    </div>
    <div class="w-[100%] pb-[30px] pt-[0px]">
      <app-brief-section></app-brief-section>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.4rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Request For Information Overview</p>
      </div>

      <div class="mx-auto p-[10px] space-y-6">
        <div class="text-[20px] font-medium text-[#21252A] pb-2">
          GENERAL INFORMATION
        </div>

        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700"
        >
          <div class="flex justify-between items-center !w-[67%]">
            <p class="font-medium text-[14px] text-[#21252A]">Project</p>
            <p
              class="text-[14px] text-[#21252A] font-normal w-[115px] text-start whitespace-nowrap"
            >
              Construction of ABC Tower
            </p>
          </div>

          <div class="flex justify-between items-center !w-[67%]">
            <p class="font-medium text-[14px] text-[#21252a]">RFI #</p>
            <p
              class="text-[14px] text-[#21252A] font-normal min-w-[115px] text-start"
            >
              {{ rfiInfo?.rfi_no }}
            </p>
          </div>

          <div class="flex justify-between items-center !w-[67%]">
            <p class="font-medium text-[14px] text-[#21252a]">Date</p>
            <p
              class="text-[14px] text-[#21252A] font-normal w-[115px] text-start"
            >
              17 March 2025
            </p>
          </div>

          <div class="flex justify-between items-center !w-[67%]">
            <p class="font-medium text-[14px] text-[#21252a]">Raise By</p>
            <p
              class="text-[14px] text-[#21252A] font-normal w-[115px] text-start"
            >
              John Doe
            </p>
          </div>

          <div class="flex justify-between items-center !w-[67%]">
            <p class="font-medium text-[14px] text-[#21252a]">
              For Attention of (FAO)
            </p>
            <p
              class="text-[14px] text-[#21252A] font-normal w-[115px] text-start"
            >
              Jane Smith
            </p>
          </div>

          <div class="flex justify-between items-center !w-[67%]">
            <p class="font-medium text-[14px] text-[#21252a]">Subject</p>
            <p
              class="text-[14px] text-[#21252A] font-normal w-[115px] text-start"
            >
              {{
                rfiInfo.subject.length > 25
                  ? (rfiInfo.subject | slice : 0 : 25) + "..."
                  : rfiInfo.subject
              }}
            </p>
          </div>
        </div>
        <p class="font-medium text-[16px] text-[#21252A] !mt-[35px]">
          Description of the Issue
        </p>
        <p
          class="text-[14px] text-[#21252A] font-normal w-[100%] text-start !mt-[5px]"
          [innerHTML]="getSanitizedHtml(rfiInfo?.issue)"
        ></p>
        <p class="font-medium text-[16px] text-[#21252A] !mt-[20px]">
          Request for Information / Clarification
        </p>
        <p
          class="text-[14px] text-[#21252A] font-normal w-[100%] text-start !mt-[5px]"
          [innerHTML]="getSanitizedHtml(rfiInfo?.clarification)"
        ></p>

        <div class="">
          <p
            class="font-medium text-[16px] text-[#21252A] !mt-[20px] !mb-[10px]"
          >
            Document Referenced Concerning the RFI
          </p>

          <table
            class="min-w-full text-sm text-left border border-gray-300 custom-table"
          >
            <thead class="bg-[#F1F3F5] text-[#21252A] text-[16px] font-medium">
              <tr>
                <th class="px-4 py-3">Document Referenced Number</th>
                <th class="px-4 py-3 text-left">Comments</th>
              </tr>
            </thead>
            <tbody class="text-[#21252A] text-[14px] font-normal">
              <tr
                class="border-b border-gray-200"
                *ngFor="
                  let attachment of rfiInfo?.rfi_referenced_concerning_attach
                "
              >
                <td class="px-4 py-3">
                  <a
                    target="_blank"
                    #downloadRfiContractorDocumentLink
                    [href]="docUrl || '#'"
                    (click)="
                      $event.stopPropagation();
                      downloadDocuments(
                        $event,
                        downloadRfiContractorDocumentLink,
                        attachment?.id,
                        attachment?.file_path
                      )
                    "
                    class="text-blue-700 underline"
                  >
                    {{ attachment?.title }}
                  </a>
                </td>
                <td class="px-4 py-3 text-left">
                  {{
                    attachment?.comment
                      ? attachment?.comment
                      : "No Comment Added"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="font-medium text-[16px] text-[#21252A] !mt-[20px]">
          Recommendations (Optional)
        </p>
        <p
          class="text-[14px] text-[#21252A] font-normal w-[100%] text-start !mt-[5px]"
          [innerHTML]="getSanitizedHtml(rfiInfo?.recommendation)"
        ></p>
        <div class="flex justify-start items-center gap-7 !mt-[7px]">
          <p class="font-medium text-[16px] text-[#21252A]">
            Required response Date
          </p>
          <p
            class="text-[14px] text-[#21252A] font-normal w-[115px] text-start"
          >
            {{ rfiInfo.response_date | date : "yyyy-MM-dd" }}
          </p>
        </div>
      </div>

      <ng-container *ngIf="rfiInfo?.rfi_responses.length > 0">
        <p class="text-[#21252A] text-[20px] font-medium !ml-[8px]">
          Responses
        </p>
        <div class="border p-4 bg-gray-50 mx-[8px] mb-[18px]">
          <div
            *ngFor="let response of rfiInfo?.rfi_responses"
            class="bg-white border p-4 mb-3 shadow-sm rounded"
          >
            <ng-container
              *ngIf="response.forwarded_to === null; else forwardedTemplate"
            >
              <!-- Top Row: Author | Attachments  -->
              <div class="flex justify-between items-start flex-wrap">
                <!-- Left Side: Author & Time -->
                <div class="flex flex-col">
                  <span class="font-semibold text-sm">Client </span>
                  <span class="text-xs text-gray-500">{{
                    formatDate(response?.created_at)
                  }}</span>
                </div>

                <!-- Right Side: Attachments, Checkbox, Delete -->
                <div class="flex items-center gap-6 mt-2 md:mt-0">
                  <!-- Attachments -->
                  <div class="flex flex-col justify-center gap-2 mt-[-6px]">
                    <span class="text-sm font-semibold text-gray-700"
                      >Attachments</span
                    >
                    <div>
                      <ng-container
                        *ngIf="
                          response.rf_i_response_attach.length > 0;
                          else noAttachment
                        "
                      >
                        <div class="flex flex-col gap-2">
                          <div
                            *ngFor="
                              let attachment of response.rf_i_response_attach
                            "
                          >
                            <a
                              target="_blank"
                              #downloadRfiClientDocumentLink
                              [href]="docUrl || '#'"
                              (click)="
                                $event.stopPropagation();
                                downloadDocuments(
                                  $event,
                                  downloadRfiClientDocumentLink,
                                  attachment?.id,
                                  attachment?.file_path
                                )
                              "
                              class="flex justify-start items-center gap-2"
                            >
                              <img
                                [src]="getFileIcon(attachment?.title)"
                                alt="File Preview"
                                class="object-cover w-5 h-5 cursor-pointer"
                              />
                              <span
                                class="text-sm text-blue-600 underline cursor-pointer"
                              >
                                {{
                                  attachment?.title.length > 25
                                    ? (attachment?.title | slice : 0 : 25) +
                                      "..."
                                    : attachment?.title
                                }}
                              </span>
                            </a>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noAttachment>
                        <span class="text-sm text-gray-500"
                          >No Attachment Added</span
                        >
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Message Section -->
              <div
                class="mt-3 text-sm text-gray-800 leading-relaxed"
                [innerHTML]="getSanitizedHtml(response?.response)"
              ></div>
            </ng-container>
            <ng-template #forwardedTemplate>
              <!-- Top Row: Author | Attachments  -->
              <div class="flex justify-between items-start flex-wrap">
                <!-- Left Side: Author & Time -->
                <div class="flex flex-col">
                  <span class="font-semibold text-sm">Architect</span>
                  <span class="text-xs text-gray-500">{{
                    formatDate(response?.created_at)
                  }}</span>
                </div>

                <!-- Right Side: Attachments, Checkbox, Delete -->
                <div class="flex items-center gap-6 mt-2 md:mt-0">
                  <!-- Attachments -->
                  <div class="flex flex-col justify-center gap-2 mt-[-6px]">
                    <span class="text-sm font-semibold text-gray-700"
                      >Attachments</span
                    >
                    <div>
                      <ng-container
                        *ngIf="
                          response.rf_i_response_attach_third_party.length > 0;
                          else noAttachment
                        "
                      >
                        <div class="flex flex-col gap-2">
                          <div
                            *ngFor="
                              let attachment of response.rf_i_response_attach_third_party
                            "
                          >
                            <a
                              target="_blank"
                              #downloadRfiThirqPartyDocumentLink
                              [href]="docUrl || '#'"
                              (click)="
                                $event.stopPropagation();
                                downloadDocuments(
                                  $event,
                                  downloadRfiThirqPartyDocumentLink,
                                  attachment?.id,
                                  attachment?.file_path
                                )
                              "
                              class="flex justify-start items-center gap-2"
                            >
                              <img
                                [src]="getFileIcon(attachment?.title)"
                                alt="File Preview"
                                class="object-cover w-5 h-5 cursor-pointer"
                              />
                              <span
                                class="text-sm text-blue-600 underline cursor-pointer"
                              >
                                {{
                                  attachment?.title.length > 25
                                    ? (attachment?.title | slice : 0 : 25) +
                                      "..."
                                    : attachment?.title
                                }}
                              </span>
                            </a>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noAttachment>
                        <span class="text-sm text-gray-500"
                          >No Attachment Added</span
                        >
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Message Section -->
              <div
                class="mt-3 text-sm text-gray-800 leading-relaxed"
                [innerHTML]="getSanitizedHtml(response?.third_party_response)"
              ></div>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <!-- <div class="mx-auto bg-white p-6 rounded-2xl shadow-md space-y-6">
        <div class="text-2xl font-semibold text-gray-800 border-b pb-2">
          GENERAL INFORMATION
        </div>

        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700"
        >
          <div>
            <p class="font-medium text-[18px] text-[#21252a]">Title</p>
            <p class="text-gray-900 text-[16px] font-normal">
              {{ rfiInfo.title }}
            </p>
          </div>

          <div>
            <p class="font-medium text-[18px] text-[#21252a]">Subject</p>
            <p class="text-gray-900 text-[16px] font-normal">
              {{ rfiInfo.subject }}
            </p>
          </div>

          <div>
            <p class="font-medium text-[18px] text-[#21252a]">Clarification</p>
            <p class="text-gray-900 text-[16px] font-normal">
              {{ rfiInfo.clarification }}
            </p>
          </div>

          <div>
            <p class="font-medium text-[18px] text-[#21252a]">Recommendation</p>
            <p class="text-gray-900 text-[16px] font-normal">
              {{ rfiInfo.recommendation }}
            </p>
          </div>

          <div>
            <p class="font-medium text-[18px] text-[#21252a]">Issue Date</p>
            <p class="text-gray-900 text-[16px] font-normal">
              {{ rfiInfo.issue_date }}
            </p>
          </div>

          <div>
            <p class="font-medium text-[18px] text-[#21252a]">Response Date</p>
            <p class="text-gray-900 text-[16px] font-normal">
              {{ rfiInfo.response_date }}
            </p>
          </div>
        </div>
      </div> -->
      <app-comments></app-comments>
    </div>
  </div>
</div>
